import { Col, ItemList } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

const Products = ({}) => {
  const [data, setData] = useState([]),
    store = useSelector((state) => state.store),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    { id } = useParams();

  useEffect(() => {
    if (!data?.length) getStore();
    if (!id) setData(store.suggested);
  }, [id, store.suggested]);

  async function getStore() {
    const res = await Api.get('/store/initial');
    if (!res) return;

    dispatch({
      type: 'SET_STORE',
      payload: res
    });

    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        rates: res.rates
      }
    });
  }

  return (
    <Col wid="100%" centerAll noFlex>
      <Col noFlex wid={isMobile ? '100vw' : '936px'} start center pad="0 0 64px">
        <ItemList data={data} limitless title={t('store.suggestedItems')} small />
      </Col>
    </Col>
  );
};

export default Products;
